import { render } from "./WhatWeDoItemNew.vue?vue&type=template&id=5ec1db1d&scoped=true"
import script from "./WhatWeDoItemNew.vue?vue&type=script&lang=js"
export * from "./WhatWeDoItemNew.vue?vue&type=script&lang=js"

import "./WhatWeDoItemNew.vue?vue&type=style&index=0&id=5ec1db1d&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec1db1d"]])

export default __exports__